/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_ContentInputs */

const en_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Exclusive Trees`)
};

const ar_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أشجار حصرية من بلس`)
};

const de_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Exklusive Bäume`)
};

const es_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árboles exclusivos Plus`)
};

const fr_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbres exclusifs Plus`)
};

const it_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alberi esclusivi Plus`)
};

const ja_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus限定の木`)
};

const ko_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 전용 나무`)
};

const pt_br_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Árvores exclusivas Plus`)
};

const ru_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивные деревья Plus`)
};

const th_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้นไม้สุดพิเศษสำหรับ Plus`)
};

const tr_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Özel Ağaçlar`)
};

const zh_cn_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 限定树种`)
};

const zh_tw_subscription_exclusive_content = /** @type {(inputs: Subscription_Exclusive_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 限定樹種`)
};

/**
* | output |
* | --- |
* | "Plus Exclusive Trees" |
*
* @param {Subscription_Exclusive_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_content = /** @type {((inputs?: Subscription_Exclusive_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_content(inputs)
	if (locale === "ar") return ar_subscription_exclusive_content(inputs)
	if (locale === "de") return de_subscription_exclusive_content(inputs)
	if (locale === "es") return es_subscription_exclusive_content(inputs)
	if (locale === "fr") return fr_subscription_exclusive_content(inputs)
	if (locale === "it") return it_subscription_exclusive_content(inputs)
	if (locale === "ja") return ja_subscription_exclusive_content(inputs)
	if (locale === "ko") return ko_subscription_exclusive_content(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_content(inputs)
	if (locale === "ru") return ru_subscription_exclusive_content(inputs)
	if (locale === "th") return th_subscription_exclusive_content(inputs)
	if (locale === "tr") return tr_subscription_exclusive_content(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_content(inputs)
	return zh_tw_subscription_exclusive_content(inputs)
});